import React, { useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import { Btn, H6, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { BottomLeftToasts, DoYouIntendToContinue, ImNotSure, RemoveMyAccount, YourAccountWillBePermanentlyDeleted } from "../../../../../Constant";

const BottomLeftToast = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  return (
    <>
      <Btn color="success" onClick={toggle}>{BottomLeftToasts}</Btn>
      <div className="toast-container position-fixed start-0 bottom-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={open}>
          <div className="toast-header toast-img">
            <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
            <strong className="me-auto">Boho theme</strong>
            <Btn className="btn-close" onClick={() => setOpen(false)}></Btn>
          </div>
          <ToastBody className="toast-dark">
            <H6 className="mb-2">{YourAccountWillBePermanentlyDeleted}</H6>
            <P className="mb-0">{DoYouIntendToContinue}</P>
            <div className="mt-2 pt-2 border-top d-flex gap-2">
              <Btn color="dark" size="sm">{ImNotSure}</Btn>
              <Btn color="danger" size="sm" onClick={() => setOpen(false)}>{RemoveMyAccount}</Btn>
            </div>
          </ToastBody>
        </Toast>
      </div>
    </>
  );
};

export default BottomLeftToast;
